import { ref } from "vue";
import axios from "axios";

export type FeatureFlags = {
  powerBIReporting: boolean;
  locTimeline: boolean;
};

const features = ref<FeatureFlags | null>(null);
const loading = ref(false);
const error = ref<string | null>(null);

export async function loadFeatures(): Promise<FeatureFlags | null> {
  if (features.value) return features.value;
  if (loading.value) return features.value;

  loading.value = true;
  error.value = null;

  try {
    const { data } = await axios.get<FeatureFlags>("/api/features");
    features.value = data;
    return features.value;
  } catch (e: any) {
    error.value = e?.message ?? "Failed to load feature flags";
    features.value = { powerBIReporting: false, locTimeline: false  };
    return features.value;
  } finally {
    loading.value = false;
  }
}

export function useFeatures() {
  return { features, loading, error, loadFeatures };
}